import React from 'react';
import { Button } from './Button';
import { ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="bg-white-soft py-20 px-6" data-id="element-187">
      <div className="max-w-4xl mx-auto bg-navy rounded-3xl shadow-2xl overflow-hidden border border-gold/20" data-id="element-188">
        <div className="bg-gold text-navy-dark text-center py-3 font-bold text-lg tracking-wide uppercase" data-id="element-189">
          Oferta Especial
        </div>

        <div className="p-8 md:p-12 text-center text-white-soft" data-id="element-190">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-191">
            Obtén el Bundle Completo de{' '}
            <span className="text-gold" data-id="element-192">Legado Digital Seguro</span> hoy mismo
          </h2>

          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-193">
            Protege tu historia y el futuro financiero de tu familia por una
            fracción de lo que costaría una sola consulta con un abogado
            especializado.
          </p>

          <div className="mb-10" data-id="element-194">
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-195">
              <span className="text-gray-400 text-lg line-through" data-id="element-196">
                Valor: $27 USD
              </span>
              <span className="bg-green-500 text-white text-sm font-bold px-3 py-1 rounded-full" data-id="element-197">
                -76% OFF
              </span>
            </div>
            <div className="text-6xl font-bold text-gold my-4 font-serif" data-id="element-198">
              $6.39 <span className="text-2xl text-gold-dark" data-id="element-199">USD</span>
            </div>
            <span className="text-sm text-gray-400 uppercase tracking-widest" data-id="element-200">
              Precio Único • Acceso de por vida
            </span>
          </div>

          <div className="flex justify-center mb-8" data-id="element-201">
            <Button className="text-xl py-5 px-10 shadow-gold/30 shadow-2xl animate-pulse hover:animate-none" data-id="element-202">
              ¡SÍ, QUIERO PROTEGER A MI FAMILIA AHORA!
            </Button>
          </div>

          <div className="flex items-center justify-center text-gray-400 text-sm" data-id="element-203">
            <ShieldCheck className="w-5 h-5 mr-2 text-green-400" data-id="element-204" />
            Compra 100% segura con garantía de satisfacción.
          </div>
        </div>
      </div>
    </section>;
}